<template>
  <div class="baby_select_dialog_embed" :style="{'top': scrollTop + 'px', 'left': scrollLeft + 'px'}">
    <div class="baby_dialog_embed_box">
      <!--弹出框头部-->
      <div class="select_dialog_embed_box_top">
        <p>{{title}}</p>
      </div>

      <!--弹出框信息-->
      <div class="select_dialog_embed_box_content">
        <!--店铺货品列表之链接详情同步库存-->
        <div v-if="showType === 'sglLinkDetail' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否需要同步此链接的库存？同步完成后链接对应的该货品的库存会进行改变！</div>

        <!--店铺货品列表之同步库存-->
        <div v-if="showType === 'setInventoryDocking' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否要重新设置货号库存对接？设置完成后对应链接的该货品的库存会进行改变！</div>

        <!--店铺货品列表之上下架-->
        <div v-if="showType === 'numUpDown' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否对此货号进行{{upDownValue}}操作？</div>

        <!--店铺链接列表之链接详情-->
        <div v-if="showType === 'sllLinkDetail' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否要修改平台商家编码？修改后3~30分钟后系统会对链接库存进行更新！</div>

        <!--店铺链接列表之设置库存对接-->
        <div v-if="showType === 'sllSetInventoryObject' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否要重新设置链接库存对接？设置完成后链接库存会进行改变！</div>

        <!--店铺链接列表之链接上下架-->
        <div v-if="showType === 'sllNumUpDown' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否对此链接进行{{upDownValue}}操作？</div>

        <!--无法识别链接列表之同步商家编码-->
        <div v-if="showType === 'cannotLinkDetail' && !isLoading" class="mt30 mr30 ml30 mb30">请确定是否要修改平台商家编码？修改后3~30分钟后系统会对链接库存进行更新！</div>

        <!--加载时的内容-->
        <div v-if="isLoading" class="select_dialog_embed_box_loading">
          <img src="../../../../assets/img/pic_loading.gif" alt="加载中">
          <span>操作正在进行中，请勿关闭浏览器或页面........</span>
        </div>
      </div>

      <!--弹出框底部-->
      <div v-if="!isLoading" class="select_dialog_embed_box_bottom">
        <button class="btn_normal" @click="submitBtn()">确定</button>
        <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../../public-component/msg-dialog';

  export default {
    name: 'baby-dialog',
    /**
     *  title：  头部名
     *  showType: goodDetail=货品详情信息
     *  msg: 信息
     * */
    props: ['title', 'showType', 'msg', 'upDownValue'],
    components: {MsgDialog},
    filters: {},
    data() {
      return {
        scrollTop: 0, // 滚动的高度
        scrollLeft: 0, // 滚动的宽度
        isLoading: false, // 显示加载框
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 店铺链接--修改链接商家编码后同步库存
      synchrBatchLinkBusinessCode() {
        this.isLoading = true;
        let params = [];
        for (let i = 0; i < this.msg.length; i++) {
          if (this.msg[i].linkskuInfo.length) {
            for (let j = 0; j < this.msg[i].linkskuInfo.length; j++) {
              params.push({
                shopId: this.msg[i].ShopId,
                userId: sessionStorage.getItem('userId'),
                numId: this.msg[i].NumId,
                linkSkuId: this.msg[i].linkskuInfo[j].skuId,
                businessCode: this.msg[i].GroupBusinessCode,
                price: this.msg[i].linkskuInfo[j].price,
                stockNum: this.msg[i].LinkSkuQty
              });
            }
          }
        }
        this.$axios.post(this.Global.synchrBatchLinkBusinessCode, params).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              // this.cancelBtn(true);
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功';
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          }
        });
      },

      // 无法识别链接--同步商家编码
      synchrBatchBusinessCode() {
        this.isLoading = true;
        let params = [];
        if (this.msg.linkerrorskuInfo.length) {
          for (let j = 0; j < this.msg.linkerrorskuInfo.length; j++) {
            params.push({
              shopId: this.msg.ShopId,
              userId: sessionStorage.getItem('userId'),
              numId: this.msg.NumId,
              linkSkuId: this.msg.linkerrorskuInfo[j].SkuId,
              businessCode: this.msg.linkerrorskuInfo[j].OuterId
            });
          }
        }
        // console.log(params);
        this.$axios.post(this.Global.synchrBatchBusinessCode, params).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              // this.cancelBtn(true);
              this.isMsg = true;
              this.isSuc = true;
              this.txtMsg = '操作成功';
            } else {
              this.isLoading = false;
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'sglLinkDetail') { // 店铺货品列表的链接详情--单个货号下单个链接同步库存
          // 正确
          /* this.isLoading = true;
           this.cancelBtn(); */
          // 错误
          this.isLoading = true;
          this.cancelBtn(true);
        } else if (this.showType === 'setInventoryDocking') { // 店铺货品列表--设置库存对接
          // this.cancelBtn();
          // this.isShowMsgDialog = true;
          this.isLoading = true;
          this.cancelBtn(true);
        } else if (this.showType === 'numUpDown') { // 店铺货品列表货品上下架
          this.isLoading = true;
          this.cancelBtn(true);
        } else if (this.showType === 'sllLinkDetail') { // 店铺链接--修改链接商家编码后同步库存
          this.synchrBatchLinkBusinessCode();
          // 正确
          /* this.isLoading = true;
           this.cancelBtn(); */
          // 错误
          // this.isShowMsgDialog = true;
          // this.isLoading = true;
          // this.cancelBtn(true);
        } else if (this.showType === 'sllSetInventoryObject') { // 店铺链接列表--设置库存对接
          this.isLoading = true;
          this.cancelBtn(true);
        } else if (this.showType === 'sllNumUpDown') { // /店铺链接列表链接上下架
          this.isLoading = true;
          this.cancelBtn(true);
        } else if (this.showType === 'cannotLinkDetail') { // 无法识别链接--同步商家编码
          // 正确
          /* this.isLoading = true;
           this.cancelBtn(); */
          // 错误
          /* this.isShowMsgDialog = true;
          this.cancelBtn(true); */
          this.synchrBatchBusinessCode();
        }
      },

      // 取消按钮
      cancelBtn(handleType) {
        // 计时器
        if (this.isLoading) {
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              clearInterval(self.timer);
              self.$emit('cancelmsgbtn', {isShow: false, handleType: handleType});
              self.isLoading = false;
            }
          }, 1000);
        } else if (this.isMsg) {
          this.isSuc = false;
          this.txtMsg = '这里是错误信息';
          this.time = 3;
          const self = this;
          this.timer = setInterval(function () {
            self.time = --self.time;
            if (self.time < 1) {
              clearInterval(self.timer);
              this.isMsg = false;
              self.$emit('cancelmsgbtn', {isShow: false, handleType: handleType});
            }
          }, 1000);
        } else {
          this.$emit('cancelmsgbtn', {isShow: false, handleType: handleType});
        }
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.showType === 'cannotLinkDetail' && this.isSuc) {
          this.cancelBtn(true);
        } else if (this.showType === 'sllLinkDetail' && this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      this.scrollTop = document.querySelector('.select_dialog_embed').scrollTop;
      this.scrollLeft = document.querySelector('.select_dialog_embed').scrollLeft;
      if (this.showType === 'sglSynchronizationOfInventory') {
        // 店铺货品列表同步库存
        this.isLoading = true;
        // this.cancelBtn();
      } else if (this.showType === 'sllSynchronizationOfInventory') {
        // 店铺链接列表同步库存
        this.isLoading = true;
        // this.cancelBtn();
      } else if (this.showType === 'redownloadLink') {
        // 无法识别链接列表重新下载链接
        this.isLoading = true;
        this.cancelBtn(false);
      } else if (this.showType === 'loading') {
        this.isLoading = true;
        this.cancelBtn(false);
      }
    },
    activated() {
      this.scrollTop = document.querySelector('.select_dialog_embed').scrollTop;
      this.scrollLeft = document.querySelector('.select_dialog_embed').scrollLeft;
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/base-color";

  .baby_select_dialog_embed {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .baby_dialog_embed_box {
      background-color: $cfff;

      .select_dialog_embed_box_top {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background-color: rgba(247, 247, 248, 1);
        border-bottom: 1px solid #eeeeee;

        p {
          width: 94%;
          margin: auto;
        }
      }

      .select_dialog_embed_box_content {
        overflow: hidden;

        .select_dialog_embed_box_handle {
          width: 80%;
          margin: 30px auto 0;

          & > div {
            margin-bottom: 20px;

            label {
              display: inline-block;
              width: 70px;
              text-align: right;
              margin-right: 10px;
            }

            input {
              width: 70%;
            }

            .warn {
              width: 60%;
              height: 20px;
              line-height: 20px;
              margin: -10px auto 0;
              color: $cred;
            }
          }
        }

        .select_dialog_embed_box_loading {
          overflow: hidden;
          margin-top: -20px;
          margin-bottom: -20px;

          img {
            float: left;
            margin-left: -25px;
          }

          span {
            display: inline-block;
            height: 130px;
            line-height: 130px;
            float: left;
            margin-left: -50px;
            margin-right: 50px;
          }
        }
      }

      .select_dialog_embed_box_bottom {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        text-align: right;

        button {
          margin-right: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/baby-dialog.vue